
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import UserSidebar from '../components/UserSidebar';
import UserHeader from '../components/UserHeader';
import '../styles/userLayout.css';

const UserLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!sidebarOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setSidebarOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [sidebarOpen]);

  const openSidebar = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="user-layout">
      {sidebarOpen && (
        <button
          type="button"
          className="user-sidebar-overlay"
          aria-label="Close navigation menu"
          onClick={closeSidebar}
        />
      )}

      <UserSidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />

      <div className="user-layout-main">
        <UserHeader onMenuClick={openSidebar} />

        <main className="user-layout-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserLayout;
